import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NgChartsModule } from 'ng2-charts';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { SwiperModule } from 'swiper/angular';
import { environment } from '../environments/environment';
// import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
// import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import {WebcamModule} from 'ngx-webcam';
// import { IonicServerModule } from '@ionic/angular-server';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    WebcamModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    SwiperModule,
    // IonBottomSheetModule,
    NgChartsModule,
    NgxQRCodeModule,
    // Chart,
    IonicModule.forRoot(),
    NgxMaskModule.forRoot(),
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
],
providers: [
    // Camera,
    Geolocation,
    // { provide: Camera, useClass: CameraMock },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
],
bootstrap: [AppComponent]
})
export class AppModule {}
